import React, { lazy, Suspense } from "react";
import SubPageLoading from "views/pages/SubPageLoading";
const LineContainer = lazy(() => import("./LineContainer"));

export const LineLazy = props => (
  <Suspense fallback={<SubPageLoading height={"100vh"} />}>
    <LineContainer {...props} />
  </Suspense>
);
LineLazy.displayName = "Line";

export default LineLazy;
